import { heroData } from '@/mocks/homeData';

export default function Hero() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left animate-fade-in-up">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-medium mb-5 whitespace-nowrap">
              {heroData.tag}
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              {heroData.h1}
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-medium mb-5">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl lg:max-w-none mb-7">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading text-primary-500">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                onClick={(e) => { e.preventDefault(); handleClick(heroData.primaryCta.href); }}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm md:text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                {heroData.primaryCta.text}
              </a>
              <a
                href={heroData.secondaryCta.href}
                onClick={(e) => { e.preventDefault(); handleClick(heroData.secondaryCta.href); }}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full border-2 border-foreground-200 text-foreground-700 font-medium text-sm md:text-base hover:border-primary-300 hover:text-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                {heroData.secondaryCta.text}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end animate-fade-in">
            <div className="relative w-full max-w-lg">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/30 via-accent-200/20 to-primary-100/30 rounded-2xl blur-xl"></div>
              <div className="relative rounded-2xl overflow-hidden border-2 border-background-200">
                <img
                  src={heroData.heroImage}
                  alt="黄桃视频 - 免费高清影视在线观看平台主视觉"
                  className="w-full h-auto object-cover aspect-[4/3]"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    const parent = target.parentElement;
                    if (parent) {
                      parent.classList.add('hidden');
                    }
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/20 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></div>
                  <span className="text-xs text-background-50 font-medium">正在热播中</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}